<template>
  <div class="text-xs-center" style="text-align:left !important">
    
	<!-- <v-btn @click="type='nodejs'; typeSelected='nodejs'">NodeJs</v-btn>    	
	<v-btn @click="type='scatter'; typeSelected='scatter'">Scatter</v-btn> -->
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Claim your EOS user account
        </v-card-title>

		<v-stepper v-if="typeSelected == 'scatter'" v-model="e1" vertical>
		    <v-stepper-header>
		      <v-stepper-step editable :complete="e1 > 0" step="0">Download Scatter</v-stepper-step>
 
		      <v-divider></v-divider>

		      <v-stepper-step editable :complete="e1 > 1" step="1">Create blockchain account</v-stepper-step>

		      	
		      <v-divider></v-divider>

		      <!-- <v-stepper-step editable step="3">Add transaction code</v-stepper-step> -->
		    </v-stepper-header>
<!--       <v-stepper-header>
        <v-stepper-step
          editable
          step="1"
        >
          Select campaign settings
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          editable
          step="2"
        >
          Create an ad group
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          step="3"
          editable
        >
          Create an ad
        </v-stepper-step>

         <v-divider></v-divider>

        <v-stepper-step
          step="3"
          editable
        >
          Create an ad
        </v-stepper-step>
      </v-stepper-header> -->

		    <v-stepper-items>

		      <v-stepper-content step="0">
		        <v-card
		          class="mb-5"
		          color="grey lighten-3"
		          height="200px"
		          style="padding:50px"
		        >

 

					<img style="width:200px; margin-right:20px" src="../../../src/assets/Scatter/scatter_logo_lines.svg"></img>
					<a style="margin-right:20px" href="https://get-scatter.com/"><v-btn>Download</v-btn></a>
					
  						<a href='https://support.get-scatter.com' target="_blank">Why should i use Scatter?</a>
					

		        </v-card>

		      </v-stepper-content>


			    <v-stepper-content step="1">
			        <v-card
			          class="mb-5"
			          color="grey lighten-3"
			          height="360px"
			          style="padding:20px;"
			        >

			        
			        	<AccountCreate></AccountCreate>


			        </v-card>

		      </v-stepper-content>


		      
		    </v-stepper-items>
		  </v-stepper>

		  <!-- ############################################################################################ -->

		 <!--  <v-stepper v-if="typeSelected == 'nodejs'" v-model="e1" vertical>
		    <v-stepper-header>
		      <v-stepper-step :complete="e1 > 1" step="1">Download Scatter</v-stepper-step>

		      	
		      <v-divider></v-divider>

		      <v-stepper-step :complete="e1 > 2" step="2">Install Dependencys</v-stepper-step>

		      <v-divider></v-divider>

		      <v-stepper-step step="3">Add transaction code</v-stepper-step>

		      <v-divider></v-divider>

		      <v-stepper-step step="4">Prepare Scatter with EOS account</v-stepper-step>
		    </v-stepper-header>

		    <v-stepper-items>
		      <v-stepper-content step="1">
		        <v-card
		          class="mb-5"
		          color="grey lighten-1"
		          height="200px"
		        >

 

					<img style="width:200px" src="../../../src/assets/Scatter/scatter_logo_lines.svg"></img>
					<a href="https://get-scatter.com/"><v-btn>Download</v-btn></a>
					
  						<a href='https://support.get-scatter.com'>Scatter infomationn</a>
					

		        </v-card>

		        <v-btn
		          color="primary"
		          @click="e1 = 2"
		        >
		          Continue
		        </v-btn>

		        <v-btn flat>Cancel</v-btn>
		      </v-stepper-content>

		      <v-stepper-content step="2">
		        <v-card
		          class="mb-5"
		          color="grey lighten-1"
 
		        >
		        <span class="title"></span>

		        </v-card>

		        <v-btn
		          color="primary"
		          @click="e1 = 3"
		        >
		          Continue
		        </v-btn>

		        <v-btn flat>Cancel</v-btn>
		      </v-stepper-content>

		      <v-stepper-content step="3">
		        <v-card
		          class="mb-5"
		          color="grey lighten-1"
		          
		        >
		        	    <pre>

				        <code style=" padding:20px" class="javascript">


				        </code>
				    </pre>
		        </v-card>


		        <v-btn
		          color="primary"
		          @click="e1 = 4"
		        >
		          Continue
		        </v-btn>

		        <v-btn flat>Cancel</v-btn>
		      </v-stepper-content>
		       <v-stepper-content step="4">
		        <v-card
		          class="mb-5"
		          color="grey lighten-1"
		          height="200px"
		        ></v-card>

		        <v-btn
		          color="primary"
		          @click="dialog = false; el = 0"
		        >
		          Continue
		        </v-btn>

		        <v-btn flat>Cancel</v-btn>
		      </v-stepper-content>
		    </v-stepper-items>
		  </v-stepper> -->
 <!--        <v-divider></v-divider> -->
      </v-card>
 
  </div>
</template>

<script>
	import AccountCreate from '../BasicUserAccountClaim/CreateAccount'
 
  export default {
  	components: {
  		AccountCreate
  	},
  	mounted: function  () {
  		console.log(this.open)
  		this.$store.dispatch('eosJsFunc/keyCreate')

  	},
    data () {
      return {
        e1: 0,
        dialog: true,
        typeSelected: 'scatter',
        type: '',
      }
    },
    props: { open: Boolean },
    computed: {
    	dialogOpen: function () {
    	 	console.log(this.open)
	    	return this.open
	    }
    },
    methods: {
    	closeDialog: function () {
    		 
    			this.$emit('connectClosed', false)
  
    		
    	}
    }
  }
</script>


<style scoped>

  /**
 * prism.js Funky theme
 * Based on “Polyfilling the gaps” talk slides http://lea.verou.me/polyfilling-the-gaps/
 * @author Lea Verou
 */

code[class*="language-"],
pre[class*="language-"] {
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  font-size:20px;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  background-color:black !important;

  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;

  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

/* Code blocks */
pre[class*="language-"] {
  padding: .4em .8em;
  margin: .5em 0;
  overflow: auto;
  background: url('data:image/svg+xml;charset=utf-8,<svg%20version%3D"1.1"%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"100"%20height%3D"100"%20fill%3D"rgba(0%2C0%2C0%2C.2)">%0D%0A<polygon%20points%3D"0%2C50%2050%2C0%200%2C0"%20%2F>%0D%0A<polygon%20points%3D"0%2C100%2050%2C100%20100%2C50%20100%2C0"%20%2F>%0D%0A<%2Fsvg>');
  background-size: 1em 1em;
}

code[class*="language-"] {
  background: black;
  color: white;
  box-shadow: -.3em 0 0 .3em black, .3em 0 0 .3em black;
}

/* Inline code */
:not(pre) > code[class*="language-"] {
  padding: .2em;
  border-radius: .3em;
  box-shadow: none;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #aaa;
}

.token.punctuation {
  color: #999;
}

.namespace {
  opacity: .7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol {
  color: #0cf;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin {
  color: yellow;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.toke.variable,
.token.inserted {
  color: yellowgreen;
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: deeppink;
}

.token.regex,
.token.important {
  color: orange;
}

.token.important,
.token.bold {
  font-weight: bold;
}
.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

.token.deleted {
  color: red;
}


</style>